import { prependBackendAPIHost } from "repoV2/utils/common/api/api";

export const logout_api_url = prependBackendAPIHost(
    "users/exly/customer/logout"
);
